import { render, staticRenderFns } from "./LearningCourse.vue?vue&type=template&id=7276e8bc&scoped=true&"
var script = {}
import style0 from "./LearningCourse.vue?vue&type=style&index=0&id=7276e8bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7276e8bc",
  null
  
)

export default component.exports